module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/Shintoku-aa709f7456f1e77e156fff7024f4fdb7.jpg";